import {Row} from '@jetbrains/ring-ui/components/grid/grid'
import classNames from 'classnames'
import type * as React from 'react'

import styles from './ListItem.css'

function ListItem(props: {
  children?: React.ReactNode
  className?: string
  rowClassName?: string
  hideBorders?: boolean
  hideTopBorder?: boolean
  highlightHover?: boolean
}) {
  const {
    children,
    className,
    rowClassName,
    hideTopBorder,
    hideBorders,
    highlightHover,
    ...restProps
  } = props
  const classes = classNames(styles.listItem, className, {
    [styles.highlightHover]: highlightHover,
    [styles.hideBorders]: hideBorders,
    [styles.hideTopBorder]: hideTopBorder,
  })
  const rowClasses = classNames(styles.row, rowClassName)
  return (
    <div {...restProps} className={classes}>
      <Row baseline="xs" className={rowClasses}>
        {children}
      </Row>
    </div>
  )
}

export default ListItem
